import { render, staticRenderFns } from "./ComplexExercises.vue?vue&type=template&id=487d884f&scoped=true&"
import script from "./ComplexExercises.vue?vue&type=script&lang=js&"
export * from "./ComplexExercises.vue?vue&type=script&lang=js&"
import style0 from "./ComplexExercises.vue?vue&type=style&index=0&id=487d884f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d884f",
  null
  
)

export default component.exports